import { useCreateTeamForm } from "../../../hooks/kuitan/useCreateTeamForm";
import { useCreateTeam } from "../../../hooks/kuitan/useCreateTeam";
import { TeamForm } from "../../organisms/kuitan/TeamForm";


export const CreateTeam = () => {
  const { handleSubmit, register, control, isSubmitting, errors } = useCreateTeamForm();
  const onSubmit = useCreateTeam()
  return <TeamForm onSubmit={handleSubmit(onSubmit)} isSubmitting={isSubmitting} register={register} errors={errors} control={control} cardHeading='チーム作成' btnLabel='作成'/>;
}